var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form-send" } }, [
    _c("div", { class: "form-send start-align-" + _vm.localAlign }, [
      _c("button", [_vm._v(_vm._s(_vm.localLabel))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }